import React, { useEffect, useState, useContext } from "react";
import { callAPI } from "utils/API";
import { Col, Row, Alert, Modal } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import { AppContext } from "contexts/AppContext";
import Menu from "../../icons/Menu";
import Search, { Lens } from "../../icons/Search";
import Account2 from "../../icons/Account2";
import FavouriteBorder from "../../icons/FavouriteBorder";
import Shop from "../../icons/shop";
import ShoppingCart from "../../icons/ShoppingCart";
import Headline6 from "components/elements/Headline6"
import ContentSmall from "components/elements/ContentSmall"
import { useNavigate } from "react-router-dom"
import ButtonMedium1 from "components/elements/ButtonMedium1";
import ButtonMedium4 from "components/elements/ButtonMedium4";
import Drawer from "components/blocks/drawer/Drawer";
import Close from "components/icons/Close";
import './Header.css'
import ContentLarge from "components/elements/ContentLarge";
import Activity from "utils/Activity";
import { translate } from "utils/Translate";
import { pointsConvertor } from "utils/general";
import { ShopMenu } from "./Header";
import { Select, useMediaQuery } from "@mui/material";
import CustomSelectHeader from "components/elements/CustomSelectHeader";

function Header1(props) {
  const { style, className, pointsUpdate, hidePointsUpdate } = props
  const [show, setShow] = useState(false);
  const [shopHeading, setShopHeading] = useState(null)
  const [shopURL, setShopURL] = useState(null);
  const [hofURL, setHOFURL] = useState(null);
  const [teamAccess, setTeamAccess] = useState();
  const [announcements, setAnnouncements] = useState();
  const [showConfirmLogout, setShowConfirmLogout] = useState(false);
  const handleClose = () => setShow(false);
  const { brandData, menuData, styleGuide, userData, basket, setshowBasketQuickView, setStatusscroll, setUserData, langCode } = useContext(AppContext);
  const navigate = useNavigate();
  const brandLogoHeight = brandData && brandData.features && brandData.features.brandLogoHeight ? `${brandData.features.brandLogoHeight}px` : '35px';
  const brandLogoWidth = brandData && brandData.features && brandData.features.brandLogoWidth ? `${brandData.features.brandLogoWidth}px` : 'auto';
  const headerBgColor = brandData && brandData.features && brandData.features.headerBackground ? brandData.features.headerBackground : 'white';
  const menuBarBgColor = brandData?.features?.themeOneMenuBarBackgroundColor || "#212529" // hexcode is reac-bootstrap's navbar dark shade
  const menuBarTextColor = brandData?.features?.themeOneMenuBarTextColor || styleGuide.color1;
  const isStarkBrand = brandData && brandData.BrandID === 87;
  const [customers, setCustomers] = useState(null);
  const [customerData, setCustomerData] = useState(null)
  const [selectedCustomerNumber, setSelectedCustomerNumber] = useState(null);
  const isMobile = useMediaQuery('(max-width:900px)'); 
  const clearSession = () => {
    localStorage.clear()
    navigate('/logout')
  }

  useEffect(() => {
    if (brandData.BrandID == 87) {
      fetchAccounts()
    }
  }, [])

  const fetchAccounts = async () => {
    const customers = await callAPI(`/stark/getCustomers`);
    let customerArray = [];
    //console.log(customers)
    if (customers) {
      customers.map((e) => {
        customerArray.unshift({value: e.customerNumber, label: e.name + " (" + e.customerNumber + ")"})
      })
      setCustomers(customerArray)
      setCustomerData(customers)
      setUserData({ ...userData, selectedCustomerNumber: customers[0].customerNumber })
      setSelectedCustomerNumber(customers[0].customerNumber)
    }
  };

  const setCurrentAccount = async (account = null) => {
    let currentAccount = userData.customerNumber;
    if (account) {
      if (currentAccount == account) {
      } else {
        const customer = customerData.filter((x) => x.customerNumber === account);
        const balance = await callAPI(`/stark/getBalance`, 'GET', {}, null, account);
        setUserData({ ...userData, 
          selectedCustomerNumber: account, 
          walletAmountPoints: balance,
          userCompany: customer[0].name,
          userCompanyUID: customer[0].cvr,
          userAddress: customer[0].invoiceAddress ? `${customer[0].invoiceAddress.addressLine1} ${customer[0].invoiceAddress.addressLine2}` : '',
          userZipcode: customer[0].invoiceAddress ? customer[0].invoiceAddress.zipCode : '',
          userCity: customer[0].invoiceAddress ? customer[0].invoiceAddress.city : '' 
        })
        setSelectedCustomerNumber(account)
      }
    }
  }   



  const ShopsMenu = () => {
    if (!menuData || !menuData.length) return null
    const shopMenuItem = menuData.filter(menu => menu.poolName.toLowerCase() === 'shop')
    if (!shopMenuItem || !shopMenuItem.length) return null
    
    const title = !!shopMenuItem[0] && !!shopMenuItem[0].translations && !!shopMenuItem[0].translations.length > 0
    ? shopMenuItem[0].translations.find(
      (translation) => translation.languageKey === langCode
      ) 
      ? shopMenuItem[0].translations.find(
        (translation) => translation.languageKey === langCode
    ).menuTitle
        : shopMenuItem[0].menuTitle
        : shopMenuItem[0].menuTitle

    setShopHeading(title || "Shop")

    const shops = shopMenuItem[0].pool
    if (shops.length === 1) {
      const link = `/shop/${shops[0].ShopID}`
      return <Nav.Link
        key='single-shop-link'
        style={menuItem}
        onClick={() => {
          handleClose();
          Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Shop',activityArgumentID: shops[0].ShopID})
          navigate(`${link}`);
        }}
      >
        {title}
      </Nav.Link>
    }
    if (shops.length > 1) {
      const menuItems = shops.map(shop => {
        const link = `/shop/${shop.ShopID}`
        const title = !!shop && !!shop.translations && !!shop.translations.length > 0
        ? shop.translations.find(
                (translation) => translation.languageKey === langCode
        ) 
        ? shop.translations.find(
            (translation) => translation.languageKey === langCode
        ).moduleName
            : shop.moduleName
        : shop.moduleName
        return <Nav.Link
          key={shop.ShopID}
          style={subMenuItem}
          onClick={() => {
            handleClose();
            Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Shop',activityArgumentID: shop.ShopID})
            navigate(`${link}`);
          }}
        >
          - {title}
        </Nav.Link>
      })

      return <>
        <Nav.Link
          key='shop-wrapper-link'
          style={menuItem}
          onClick={() => {
            Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Shop',activityArgumentID: ''})
            navigate(`${shopURL}`);
          }}
        >
          {title}
        </Nav.Link>
        {menuItems} 
        {/* /*shop below*/ }
      </>
    }
  }

  const NewsMenu = () => {
    if (!menuData || !menuData.length) return null

    const blogMenuItem = menuData.filter(menu => menu.poolName.toLowerCase() === 'blog')
    if (!blogMenuItem || !blogMenuItem.length) return null

    const blogs = blogMenuItem[0].pool
    const newsBlogs = blogs.filter(blog => blog.blogType === 'NEWS')

    if (!newsBlogs || !newsBlogs.length) return null

    if (newsBlogs.length === 1) {
      const link = '/posts'
      const title = !!blogMenuItem[0] && !!blogMenuItem[0].translations && !!blogMenuItem[0].translations.length > 0
      ? blogMenuItem[0].translations.find(
              (translation) => translation.languageKey === langCode
      ) 
      ? blogMenuItem[0].translations.find(
          (translation) => translation.languageKey === langCode
      ).menuTitle
          : blogMenuItem[0].menuTitle
      : blogMenuItem[0].menuTitle
      return <Nav.Link
        key='single-newsBlog-link'
        style={menuItem}
        onClick={() => {
          handleClose();
          Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Blog',activityArgumentID: ''})
          navigate(`${link}`);
        }}
      >
        {title}
      </Nav.Link>
    }

    if (newsBlogs.length > 1) {
      const menuItems = newsBlogs.map(blog => {
        const link = `/posts/${blog.BlogID}`
        const title = !!blog && !!blog.translations && !!blog.translations.length > 0
          ? blog.translations.find(
                  (translation) => translation.languageKey === langCode
          ) 
          ? blog.translations.find(
              (translation) => translation.languageKey === langCode
          ).moduleName
              : blog.moduleName
          : blog.moduleName
        return <Nav.Link
          key={blog.BlogID}
          style={subMenuItem}
          onClick={() => {
            handleClose();
            Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Blog',activityArgumentID: blog.BlogID})
            navigate(`${link}`);
          }}
        >
          - {title}
        </Nav.Link>
      })

      const title = !!blogMenuItem[0] && !!blogMenuItem[0].translations && !!blogMenuItem[0].translations.length > 0
      ? blogMenuItem[0].translations.find(
              (translation) => translation.languageKey === langCode
      ) 
      ? blogMenuItem[0].translations.find(
          (translation) => translation.languageKey === langCode
      ).menuTitle
          : blogMenuItem[0].menuTitle
      : blogMenuItem[0].menuTitle

      return <>
        <Nav.Link
          key='shop-wrapper-link'
          style={menuItem}
          onClick={() => {
            Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Blog',activityArgumentID: ''})
            navigate(`/posts`)
          }}
        >
          {title}
        </Nav.Link>
        {menuItems}
      </>
    }
  }

  const HOFMenu = () => {
    if (!menuData || !menuData.length) return null

    const hofMenuItem = menuData.filter(menu => menu.poolName.toLowerCase() === 'halloffame')
    if (!hofMenuItem || !hofMenuItem.length) return null

    const hofs = hofMenuItem[0].pool
    // console.log(hofs)
    if (hofs.length === 1) {
      const link = `/halloffame/${hofs[0].HalloffameID}`
      const title = !!hofMenuItem[0] && !!hofMenuItem[0].translations && !!hofMenuItem[0].translations.length > 0
      ? hofMenuItem[0].translations.find(
              (translation) => translation.languageKey === langCode
      ) 
      ? hofMenuItem[0].translations.find(
          (translation) => translation.languageKey === langCode
      ).menuTitle
          : hofMenuItem[0].menuTitle
      : hofMenuItem[0].menuTitle
      return <Nav.Link
        key='single-shop-link'
        style={menuItem}
        onClick={() => {
          handleClose();
          Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Halloffame',activityArgumentID: hofs[0].HalloffameID})
          navigate(`${link}`);
        }}
      >
        {title}
      </Nav.Link>
    }
    if (hofs.length > 1) {
      const menuItems = hofs.map(hof => {
        const link = `/halloffame/${hof.HalloffameID}`
        const title = !!hof && !!hof.translations && !!hof.translations.length > 0
          ? hof.translations.find(
                  (translation) => translation.languageKey === langCode
          ) 
          ? hof.translations.find(
              (translation) => translation.languageKey === langCode
          ).moduleName
              : hof.moduleName
          : hof.moduleName
        return <Nav.Link
          key={hof.HalloffameID}
          style={subMenuItem}
          onClick={() => {
            handleClose();
            Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Halloffame',activityArgumentID: hof.HalloffameID})
            navigate(`${link}`);
          }}
        >
          - {title}
        </Nav.Link>
      })
      // console.log(hofURL)

      const title = !!hofMenuItem[0] && !!hofMenuItem[0].translations && !!hofMenuItem[0].translations.length > 0
      ? hofMenuItem[0].translations.find(
              (translation) => translation.languageKey === langCode
      ) 
      ? hofMenuItem[0].translations.find(
          (translation) => translation.languageKey === langCode
      ).menuTitle
          : hofMenuItem[0].menuTitle
      : hofMenuItem[0].menuTitle

      return <>
        <Nav.Link
          key='shop-wrapper-link'
          style={menuItem}
          onClick={() => {
            Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Halloffame',activityArgumentID: ''})
            navigate(`${hofURL}`);
          }}
        >
          {title}
        </Nav.Link>
        {menuItems}
      </>
    }
  }

  const getTeamAccess = async () => {
    if (brandData?.features?.groupsHavingTeamMenuAccess?.length) {
      let groupNames = brandData.features.groupsHavingTeamMenuAccess
      let getAccess = await callAPI('/group/checkAccess', "GET", { query: { groupNames } });
      setTeamAccess(getAccess)
    }
}

  const getAnnouncements = async () => {
    let response = await callAPI('/announcements/web-pool', "GET");
    if(response?.length) {
      setAnnouncements(response)
    }
  } 
  
  useEffect(() => {
    getTeamAccess()
    getAnnouncements()
  }, [])
  
  useEffect(() => {
    if (menuData && !!menuData.length) {
      menuData.map((e, i) => {
        if (e.poolName.toLowerCase() === "shop") {
          let url = `/${e.poolName.toLowerCase()}`;
          if (!e.pool || e.pool.length === 0) return url;

          const key = Object.keys(e.pool[0]).find(
            (x) => x.toLowerCase() === `${e.poolName}ID`.toLowerCase()
          );
          setShopURL(`${url}/${e.pool[0][key]}`);
        }
        if (e.poolName.toLowerCase() === "halloffame") {
          let url = `/${e.poolName.toLowerCase()}`;
          if (!e.pool || e.pool.length === 0) return url;

          const key = Object.keys(e.pool[0]).find(
            (x) => x.toLowerCase() === `${e.poolName}ID`.toLowerCase()
          );
          setHOFURL(`${url}/${e.pool[0][key]}`);
        }
      });
    }
  }, [menuData])

  const badgeStyle = {
    width: 17,
    height: 17,
    position: 'absolute',
    top: -10,
    right: -10,
    background: styleGuide.color16,
    padding: 0,
    margin: 0,
    lineHeight: 0,
    // textAlign: 'center',
    // verticalAlign: 'middle',
    borderRadius: 5,
    fontSize: '11px',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const basketTotalAmount = basket ? basket.reduce((totalAmount, basketEntry) => basketEntry.amount + totalAmount, 0) : 0

  const pointSuffix = translate("_POINTS_SHORT_", "pt")

  return (
    <>
      <div style={{ position: "absolute", top: 0, zIndex: 1, width: "100%" }}>
        {
          announcements?.length ? announcements.map((announcement) => {
            return (
              <div class="announcement-banner" key={announcement.AnnouncementID} style={{ width: '100%', background: announcement.messageType === "INFO" ? styleGuide.color18 : announcement.messageType === "SYSTEM" ? styleGuide.color13 : styleGuide.color19, display: 'flex', alignItems: "center", height: 50, justifyContent: "center" }}>
                <marquee behavior={"scroll"} direction={"left"} style={{ color: "#ffffff", width: "80%", fontWeight: "bold", textTransform: 'capitalize' }}>{announcement.message}</marquee>
              </div>
            )
          }) : null
        }
      </div>
      <Container fluid style={{ ...HeaderPosition, ...style, top: !!announcements ? announcements.length * 50 : 0 }} className={className}>
        <Row style={{ lineHeight: "50px", height: '100%' }}>
          <Col sm={12} className="d-none d-sm-inline header-left" style={{ backgroundColor: headerBgColor }}>
            <div style={headerLogo}>
              <img
                className="clubTopHeaderLogo"
                style={{ height: brandLogoHeight, width: brandLogoWidth, cursor: 'pointer' }}
                src={brandData.brandLogo}
                onClick={() => navigate('/')}
              />
            </div>
          </Col>
          <Col sm={12}
            style={{ paddingRight: 0, paddingLeft: 0 }}
            className="header-right"
          >
            <div style={{ height: "100%" }}>
              <Navbar bg={!menuBarBgColor ? "dark" : ""} variant={"dark"} style={{ height: "100%", backgroundColor: menuBarBgColor, color: menuBarTextColor }}>
                <Container style={{ justifyContent: "end" }}>

                  <Navbar.Brand className="d-inline-flex d-sm-none mobile-header-logo" style={{ backgroundColor: headerBgColor }}>
                    <img
                      style={{ objectFit: "contain" }}
                      width={100}
                      height={60}
                      src={brandData.brandLogo}
                      onClick={() => navigate('/')}
                    />
                  </Navbar.Brand>
                  {!brandData?.features?.customHeader && <Nav className="me-auto"></Nav>}
                  <Nav className="mobileNav">
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      {teamAccess && <Nav.Link
                        title="Team"
                        onClick={() => {
                          Activity({ activityType: 'click', activityName: 'header', activityArgument: 'Team', activityArgumentID: '' })
                          navigate('/team')
                        }}
                        className="d-sm-inline"
                      >
                        <span
                          style={{
                            ...iconCSS,
                            color: menuBarTextColor,
                            fontWeight: '500',
                            fontSize: '20px'
                          }}
                        >
                          Team
                        </span>
                      </Nav.Link>}
                      {!shopURL || (isMobile && isStarkBrand) ? null :
                        <Nav.Link style={{ marginRight: '10px' }}>
                          <ShopMenu caption={shopHeading} style={{
                            color: isStarkBrand ? styleGuide.color16 : menuBarTextColor,
                            fontWeight: '500',
                            fontSize: '20px'
                          }} />
                        </Nav.Link>
                      }
                      <Navbar.Brand className="d-flex align-items-center">
                        {(!isMobile || !isStarkBrand) && <span
                          style={{
                            ...iconCSS,
                            color: menuBarTextColor,
                            cursor: 'pointer'
                          }}
                          onClick={() => {
                            Activity({ activityType: 'click', activityName: 'menu', activityArgument: 'Profile', activityArgumentID: '' })
                            navigate('/profile')
                          }}
                        >
                          <Account2 fill={menuBarTextColor} />
                        </span>}
                        {!!brandData?.features?.customHeader &&
                          <span style={{ fontSize: "18px", fontWeight: 500, cursor: 'pointer', color: menuBarTextColor }}
                            onClick={() => {
                              Activity({ activityType: 'click', activityName: 'menu', activityArgument: 'Profile', activityArgumentID: '' })
                              navigate('/profile')
                            }}>
                            {translate('_MYSIDE_', 'Min side')}
                          </span>}
                        {!brandData?.features?.customHeader && (brandData?.features?.points === false || !!brandData?.features?.hideUserPointBalance || (isStarkBrand && isMobile) ? null : <span style={{ fontSize: "18px", fontWeight: 500, color: menuBarTextColor }}>
                          {`${pointsConvertor(brandData, userData.walletAmountPoints, translate('_HEADER_POINTS_', 'point'))}`}
                        </span>)}
                      </Navbar.Brand>
                      {!!brandData?.features?.customHeader && <Navbar.Brand className="d-none d-sm-inline">
                        {brandData?.features?.points === false || !!brandData?.features?.hideUserPointBalance ? null : <span style={{ fontSize: "18px", fontWeight: 500, color: menuBarTextColor }}>
                          {`${pointsConvertor(brandData, userData.walletAmountPoints, translate('_HEADER_POINTS_', 'point'))}`}
                        </span>}
                      </Navbar.Brand>}
                      {!isStarkBrand || isMobile ? null :
                        <Nav.Link>
                          <span
                            style={{
                              color: menuBarTextColor,
                              cursor: 'pointer',
                              fontWeight: '500',
                              fontSize: '18px'
                            }}
                            onClick={() => {
                              Activity({
                                activityType: 'click',
                                activityName: 'header',
                                activityArgument: 'goToStark',
                                activityArgumentID: ''
                              });
                              window.location.href = 'https://www.stark.dk';
                            }}
                          >
                            STARK.dk
                          </span>
                        </Nav.Link>
                      }
                      {!isStarkBrand ? null :
                        <CustomSelectHeader
                          wrapperStyle={{ marginBottom: 10 }}
                          label="Konto"
                          value={selectedCustomerNumber}
                          onChange={(e) => setCurrentAccount(e.target.value)}
                          options={customers}
                        />
                      }
                      {
                        !brandData?.features?.disableWishlist &&
                        <Nav.Link
                          onClick={() => {
                            Activity({ activityType: 'click', activityName: 'header', activityArgument: 'Wishlist', activityArgumentID: '' })
                            navigate('/profile/wishlist')
                          }}
                          className="d-none d-sm-inline"
                        >
                          <span
                            style={{
                              ...iconCSS,
                              color: menuBarTextColor,
                            }}
                          >
                            <FavouriteBorder fill={menuBarTextColor} />
                          </span>
                        </Nav.Link>
                      }
                      {brandData && brandData.features && brandData.features.cartIcon === false ? null :
                        <Nav.Link
                          onClick={(e) => {
                            e.stopPropagation()
                            setshowBasketQuickView(true)
                          }}
                          className="d-sm-inline"
                        >
                          <span
                            style={{
                              ...iconCSS,
                              color: menuBarTextColor,
                              position: 'relative',
                              marginRight: 12
                            }}
                          >
                            <ShoppingCart fill={menuBarTextColor} />
                            {basketTotalAmount > 0 && <div style={badgeStyle}>{basketTotalAmount}</div>}
                          </span>
                        </Nav.Link>
                      }
                      <Nav.Link eventKey={2} onClick={(e) => {
                        e.stopPropagation()
                        setShow(true)
                      }}>
                        <span
                          style={{
                            color: menuBarTextColor,
                          }}
                        >
                          <Menu fill={menuBarTextColor} />
                        </span>
                      </Nav.Link>
                    </div>
                  </Nav>
                </Container>
              </Navbar>
            </div>
            {
              (!!pointsUpdate && pointsUpdate.showAlert && !!pointsUpdate.pointsFromLastLogin) &&
              <div className="points-notification-block" style={{ background: styleGuide.color16, color: styleGuide.color1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                  <div style={{ display: 'flex', gap: 4 }}>
                    <Headline6 style={{ color: styleGuide.color1 }} translationKey="_HEADER_POINTS_SINCE_LAST_LOGIN_HI_" fallbackText={`Hej`} />
                    <Headline6 style={{ color: styleGuide.color1 }} fallbackText={userData.userName} />
                  </div>
                  <Close fill={styleGuide.color1} onClick={hidePointsUpdate} style={{ cursor: 'pointer' }} />
                </div>
                <div style={{ display: 'flex', gap: 4 }}>
                  <ContentLarge style={{ color: styleGuide.color1 }} translationKey="_HEADER_POINTS_SINCE_LAST_LOGIN_TEXT_ONE_" fallbackText={`Siden sidst har du optjent`} />
                  <ContentLarge style={{ color: styleGuide.color1 }} fallbackText={`${pointsConvertor(brandData,pointsUpdate.pointsFromLastLogin, pointSuffix)}`} />
                </div>
                <div style={{ display: 'flex', gap: 4 }}>
                  <ContentSmall style={{ color: styleGuide.color1 }} translationKey="_HEADER_POINTS_SINCE_LAST_LOGIN_TEXT_TWO_" fallbackText={`Du har nu i alt`} />
                  <ContentSmall style={{ color: styleGuide.color1 }} fallbackText={`${pointsConvertor(brandData,userData.walletAmountPoints, pointSuffix)}`} />
                </div>
              </div>
            }
            <Drawer visible={show} closeHandler={handleClose}>
              <div style={{ ...menuPosition, paddingRight: 40, minHeight: !!announcements && announcements.length ? '110vh' : '100vh', display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginBottom: 20 }}>
                  <Close fill={styleGuide.color7} onClick={() => handleClose()} style={{ cursor: 'pointer' }} />
                </div>
                <div>
                  <p style={{ fontSize: "14px" }}>Menu</p>
                  <NewsMenu />
                  <ShopsMenu />
                  <HOFMenu />
                  {(!isStarkBrand || !isMobile) ? null : <span style={{ fontSize: "18px", fontWeight: isMobile ? 600 : 500, color: isMobile ? "black" : menuBarTextColor }}>
                    {`${pointsConvertor(brandData,userData.walletAmountPoints, translate('_HEADER_POINTS_', 'point'))}`}
                  </span>}
                </div>

                <div style={{ paddingTop: "5vw", marginTop: 100, marginBottom: 50 }}>
                  <p style={{ fontSize: "14px", lineHeight: '18px' }}>
                    {
                      translate(
                        "_MENU_OTHER_LINKS_CAPTION_",
                        "Andet"
                      )
                    }
                  </p>
                  {isStarkBrand && 
                  <Nav.Link
                  style={subMenuItem}
                  href="https://www.stark.dk"
                  onClick={() => {
                    Activity({
                      activityType: 'click',
                      activityName: 'header',
                      activityArgument: 'goToStark',
                      activityArgumentID: ''
                    });
                    navigate('/profile')}}
                >
                  STARK.dk
                  </Nav.Link>
                  } 
                  
                  <Nav.Link
                    style={subMenuItem}
                    href="#"
                    onClick={() => {
                      Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Profile',activityArgumentID: ''})
                      navigate('/profile')}}
                  >
                    {
                      isStarkBrand ? "Min Profil / Point" : 
                      translate(
                        "_MENU_MY_PROFILE_",
                        "Din Profil / Point"
                      )
                    }
                  </Nav.Link>
                  {!isStarkBrand && <Nav.Link
                    style={subMenuItem}
                    href="#"
                    onClick={() => { handleClose(); setStatusscroll(true);  Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Profile',activityArgumentID: ''})
                    navigate('/profile')}}
                  >
                    {
                      translate(
                        "_MENU_PROFILE_SETTINGS_",
                        "Indstillinger"
                      )
                    }
                  </Nav.Link>}
                  {brandData && brandData.features && brandData.features.claims && <Nav.Link
                    style={subMenuItem}

                    href="#"
                    onClick={() => {
                      Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Report',activityArgumentID: ''})
                      navigate('/indberetning')}}
                  >
                    {
                      translate(
                        "_MENU_REPORTING_",
                        "Indberetning"
                      )
                    }
                  </Nav.Link>}
                  <Nav.Link
                    style={subMenuItem}
                    href="#"
                    onClick={() => { handleClose(); Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Help',activityArgumentID: ''})
                      navigate("/help", {state:{scrollToContact:true}}) }}
                  >
                    {
                      translate(
                        "_MENU_CONTACT_",
                        "Kontakt"
                      )
                    }
                  </Nav.Link>
                  <Nav.Link
                    style={subMenuItem}
                    href="#"
                    onClick={() => { handleClose(); Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Help',activityArgumentID: ''});
                    navigate("/help", {state:{scrollToFaq:true}}) }}
                  >
                    FAQ
                  </Nav.Link>
                  <Nav.Link style={subMenuItem} href="#" onClick={() => {
                    Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Logout',activityArgumentID: ''})
                    setShowConfirmLogout(true)}}>
                    {
                      translate(
                        "_MENU_LOG_OUT_",
                        "Log ud"
                      )
                    }
                  </Nav.Link>
                </div>
              </div>
            </Drawer>
          </Col>
        </Row>
      </Container>
      <Modal show={showConfirmLogout} onHide={() => setShowConfirmLogout(false)} style={{ margin: 'auto' }} centered>
        <Modal.Header className="pb-0 border-0" closeButton style={{ fontSize: 9 }}>
          <Headline6 translationKey="_CONFIRM_LOGOUT_">Bekræft log ud </Headline6>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <ContentSmall translationKey="_CONFIRM_LOGOUT_TEXT_">Er du sikker på at du vil logge ud? </ContentSmall>
          <div style={{
            display: 'flex',
            padding: '1rem',
            justifyContent: 'space-around',
          }}>
            <ButtonMedium1 showIcon={false} translationKey="_YES_" fallbackText="Ja" onClick={() => clearSession()} />
            <ButtonMedium4 showIcon={false} translationKey="_NO_" fallbackText="Nej" onClick={() => setShowConfirmLogout(false)} />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

const HeaderPosition = {
  // position: "absolute",
  // top: 0,
  height: "100px",
  display: "flex",
  flexDirection: "column",
};

const menuPosition = {
  paddingBottom: "20px",
  paddingLeft: "50px",
  paddingTop: "30px",
};

const menuItem = {
  fontWeight: "600",
  padding: "4px 0px",
  color: "black",
  fontSize: "30px",
  lineHeight: '45px'
};

const subMenuItem = {
  fontSize: "18px",
  fontWeight: "600",
  padding: "2px 0px",
  color: "black",
  lineHeight: '28px'
};
const iconCSS = {
  marginRight: "8px",
};

const headerLogo = {
  margin: "16px 80px",
};
export default Header1;
